module.exports = "/packs/icon-pc-ef8a7bd96a4ca309dcfb6799b475d3e6.png";